import React, { useCallback } from "react";

import { faEye } from "@fortawesome/pro-solid-svg-icons/faEye";
import { faEyeSlash } from "@fortawesome/pro-solid-svg-icons/faEyeSlash";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Badge from "antd/es/badge";
import cn from "classnames";
import { useIntl } from "react-intl";

import Currency from "@mapmycustomers/shared/types/Currency";

import Bucket from "@app/scene/map/store/layers/boundaries/types/Bucket";

import styles from "./BucketItem.module.scss";

interface Props {
  bucket: Bucket;
  currencies?: Currency[];
  onToggleChange?: (payload: { id: Bucket["id"] }) => void;
}

const BucketItem: React.FC<Props> = ({ bucket, currencies, onToggleChange }) => {
  const intl = useIntl();
  const currency = currencies?.find((currency) => currency.id === bucket.currencyId);

  const handleToggleClick = useCallback(
    () => onToggleChange?.({ id: bucket.id }),
    [bucket, onToggleChange]
  );

  return (
    <div className={cn(styles.container, { [styles.hidden]: !bucket?.visible })}>
      <Badge
        className={styles.title}
        color={bucket.color}
        text={`${intl.formatNumber(bucket.range[0], {
          currency: currency?.code,
          minimumFractionDigits: 0,
          style: currency ? "currency" : undefined,
        })}${
          bucket.range[1]
            ? ` - ${intl.formatNumber(bucket.range[1], {
                currency: currency?.code,
                minimumFractionDigits: 0,
                style: currency ? "currency" : undefined,
              })}`
            : ""
        }`}
      />
      <div className={styles.actions}>
        <FontAwesomeIcon
          className={styles.hideIcon}
          icon={bucket.visible ? faEye : faEyeSlash}
          onClick={handleToggleClick}
        />
      </div>
    </div>
  );
};

export default BucketItem;
